
 import React from "react";

export default function CallToAction() {
  return (
    <div className="flex justify-center font-inter bg-pastel-saffron px-4 sm:px-6 md:px-10 lg:px-20 py-6 sm:py-8 md:py-10 lg:py-16 xl:py-20">
      <div className="w-full max-w-[1500px] bg-white rounded-[20px] shadow-[0_6px_24px_rgba(0,0,0,0.06)] overflow-hidden">
        <div className="flex flex-col justify-center items-center">
          <div className="px-6 py-10 md:px-12 md:py-12 lg:px-16 flex flex-col justify-center text-center">
            <h2 className="text-2xl md:text-3xl font-medium leading-tight text-greek-blue">
              Maximize your Marketing ROI, Turn Clicks into Meaningful
              Connections!
            </h2>

            <p className="mt-4 text-base md:text-lg text-text-secondary max-w-[900px] mx-auto leading-relaxed">
              Harness the power of WhatsApp to generate high-quality leads,
              nurture relationships, and engage with your audience effortlessly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

